import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F294A] grid place-items-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "26px 26px" }} />
      <div className="relative w-full max-w-md">
        <a href="/" className="flex items-center justify-center gap-2.5 mb-8">
          <span className="grid place-items-center h-11 w-11 rounded-xl bg-white/10"><ShieldCheck className="h-6 w-6 text-emerald-400" /></span>
          <span className="font-heading font-extrabold text-white text-xl">Central <span className="text-emerald-400">MEI</span></span>
        </a>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex items-center gap-2 mb-1"><Lock className="h-4 w-4 text-slate-400" /><p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Painel Administrativo</p></div>
          <h1 className="font-heading font-bold text-2xl text-slate-900 mb-6">Acesso restrito</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" className="mt-1.5" required />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input id="password" data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1.5" required />
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
            <Button data-testid="admin-login-button" type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full h-12 font-bold gap-2">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />} Entrar
            </Button>
          </form>
        </div>
        <a href="/" className="block text-center text-sm text-slate-400 hover:text-white mt-6">← Voltar ao site</a>
      </div>
    </div>
  );
}
